module.exports = __webpack_public_path__ + "img/Zones.27c4a136.svg";